import request from '../../utils/requests'
/** * Tag: ExpCourseTemplate */
const baseUrl ="/api/ExpCourseTemplate";

/** * 获取体验课模版列表 * @param {*} param * { *    type Desc: Required:false * } */async function _getTempList(param) {  return request(baseUrl+'/getTempList',{    method: 'GET',    params: param,  });
}

/** * 获取模版详情 * @param {*} param * { *    id Desc: Required:true * } */async function _getTempModel(param) {  return request(baseUrl+'/getTempModel',{    method: 'GET',    params: param,  });
}

/** * 获取模版类型 */async function _getTempType() {  return request(baseUrl+'/getTempType',{    method: 'GET',  });
}

/** * 获取所有元素 */async function _getAllElements() {  return request(baseUrl+'/getAllElements',{    method: 'GET',  });
}

/** * 新增模版 * @param {*} body * { *    name Desc:模版名称 Required:true *    bgmurl Desc:背景音乐 Required:true *    sharetitle Desc:分享标题 Required:true *    shareimgurl Desc:分享图片 Required:true *    type Desc:类型 Required:true *    uniquecode Desc:唯一标识 Required:true * } */async function _addTemp(body) {  return request(baseUrl+'/addTemp',{    method: 'POST',    body: body,  });
}

/** * 删除模版 * @param {*} param * { *    tempid Desc: Required:true * } */async function _delTemp(param) {  return request(baseUrl+'/delTemp',{    method: 'GET',    params: param,  });
}

/** * 添加模版页面 * @param {*} body * { *    tempid Desc:模板id Required:true *    num Desc:页面序号 Required:false *    name Desc:页面名称 Required:false *    properties Desc:特效json Required:false *    elements Desc:页面元素 json Required:false *    groups Desc:组件 json Required:false * } */async function _addTempPage(body) {  return request(baseUrl+'/addTempPage',{    method: 'POST',    body: body,  });
}

/** * 批量添加模版页面 * @param {*} body * { *    reqs Desc: Required:true * } */async function _batchAddTempPage(body) {  return request(baseUrl+'/batchAddTempPage',{    method: 'POST',    body: body,  });
}

/** * 删除模版页面 * @param {*} param * { *    pageid Desc: Required:true * } */async function _delTempPage(param) {  return request(baseUrl+'/delTempPage',{    method: 'GET',    params: param,  });
}

/** * 添加元素控件 * @param {*} body * { *    expTempElementId Desc:模版元素主键Id Required:false *    type Desc:类型 Required:false *    css Desc:样式 Required:false *    properties Desc:特效 Required:false *    name Desc:名称 Required:false *    content Desc:内容 Required:false * } */async function _addElement(body) {  return request(baseUrl+'/addElement',{    method: 'POST',    body: body,  });
}

/** * 删除元素控件 * @param {*} param * { *    eleid Desc: Required:true * } */async function _delElement(param) {  return request(baseUrl+'/delElement',{    method: 'GET',    params: param,  });
}

export default{  _getTempList,  _getTempModel,  _getTempType,  _getAllElements,  _addTemp,  _delTemp,  _addTempPage,  _batchAddTempPage,  _delTempPage,  _addElement,  _delElement}



// WEBPACK FOOTER //
// ./src/services/expCourseTemplate.js